<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'ReminderTemplateEditPanel',
  props: {
    preview: {
      type: Boolean,
      required: true,
    },
    validated: {
      type: Boolean,
      required: true,
    },
    hasFocus: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      saveState: state => state.reminders.templates.save,
    }),
    ...mapGetters({
      options: 'reminders/getReplacementOptions',
    }),
  },
  methods: {
    addValue(option) {
      this.$emit('value', option);
    },
    previewTemplate() {
      this.$emit('preview');
    },
    saveTemplate() {
      this.$emit('save');
    },
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <v-card class="reminder-template-edit-panel">
    <v-flex pa-4>
      <h3 class="text-xs-center">Preview</h3>
      <v-btn
        @click="previewTemplate"
        :disabled="saveState.loading"
        color="blue"
        class="white--text mb-3"
        block
      >
        {{ preview ? 'Edit' : 'Preview' }}
      </v-btn>
      <h3 class="text-xs-center">Insert</h3>
      <v-btn
        v-for="option in options"
        @click.prevent="addValue(option)"
        :key="option.value"
        :disabled="saveState.loading || !hasFocus"
        color="blue"
        class="white--text"
        block
      >
        {{ option.label }}
      </v-btn>
      <h3 class="text-xs-center mt-3">Actions</h3>
      <v-btn
        @click="saveTemplate"
        :disabled="saveState.loading || !validated"
        color="blue"
        class="white--text"
        block
      >
        Save
      </v-btn>
      <v-btn @click="closeDialog" :disabled="saveState.loading" class="mt-4" color="error" block>
        Close
      </v-btn>
    </v-flex>
  </v-card>
</template>

<style lang="scss">
.reminder-template-edit-panel {
  z-index: 300;
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  border-radius: 30px 0 0 30px !important;
  background-color: white;
  border: 1px solid lightgray;
}
</style>



// WEBPACK FOOTER //
// src/components/Reminders/ReminderTemplateEditPanel.vue